import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Trans, useTranslation } from 'react-i18next';
import { BRAND, REACT_APP_API_URL } from 'constants/config';
import { TMG } from 'constants/products';
import { addProduct } from 'services/account.service';
import * as Actions from 'store/modules/settings/actions';
import toast from 'utils/toast';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useAlert from 'hooks/useAlert';

const usePurchaseMessage = () => {
  const [t] = useTranslation('settings');
  const dispatch = useDispatch();
  const alert = useAlert();
  const account = useSelector((s) => s.settings.account);
  const user = useSelector((s) => s.user.user);
  const { users_record_is_admin } = user;
  const isAdmin = users_record_is_admin === '1';
  const showPurchaseModal = () => {
    alert.show({
      title: '',
      type: 'custom',
      description: (
        <Box textAlign="center">
          <Box margin="auto" maxWidth={300} mb={5}>
            <img src="/assets/svg/500messages.svg" style={{ width: '100%' }} />
          </Box>
          <Typography gutterBottom>
            <Trans ns="settings" i18nKey="get-500-additional-msg-desc">
              Get <strong>500</strong> Additional Text Messages per month for{' '}
              <strong>$12</strong> per month.
            </Trans>
          </Typography>
          <Typography variant="caption" color="textSecondary">
            {t(
              '12-will-be-added-to-invoice',
              '$12 will be added to your monthly invoice.',
            )}
          </Typography>
        </Box>
      ),
      onConfirm: onPurchase,
      confirmationText: t('confirm-purchase', 'Confirm Purchase'),
      cancellationText: 'Cancel',
    });
  };

  const onPurchase = () => {
    const env = REACT_APP_API_URL.includes('qa') ? 'qa' : 'prod';
    const productId =
      BRAND === 'TMG' ? TMG['500_message_bundle'][env] : '500_message_bundle';
    return addProduct(productId).then(
      () => {
        dispatch(Actions.loadAccount(account.account_id));
        toast.success(
          t(
            'sms-purchase-success',
            'Purchase successful! 500 Additional Text Messages per month added to your account.',
          ),
        );
      },
      (err) => {
        toast.error(err.message);
      },
    );
  };

  return {
    showPurchaseModal,
    isAllowed: isAdmin,
  };
};

export default usePurchaseMessage;
